import { Component, OnInit, trigger, animate, state, style, transition } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ScrollimateService } from "ng2-scrollimate";
import { ReferencesService } from '../references/references.service';
import { TeamService } from '../team/team.service';
import { Subscription } from "rxjs/Subscription";
import { NewsService } from '../news/news.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [
    trigger('elementState', [
      state('inactive', style({
        opacity: 0,
        visibility: 'hidden',
        display: 'none'
      })),
      state('active', style({
        opacity:  1,
        visibility: 'visible'
      })),
      state('link-active', style({
        opacity:  1,
        visibility: 'visible'
      })),
      transition('* => active', animate('100ms ease-in')),
      transition('* => inactive', animate('100ms ease-in')),
      transition('* => link-active', animate('100ms ease-in')),
    ])
  ]
})
export class HomeComponent implements OnInit {

  private scrollExecuted: boolean = false;

  public refs;
  public members;
  public actus;

  scrollimateOptions: any = {
    defaultStates: [
      {
        method: "default",
        state: "active",
      }
    ],
    job: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 25,
          state: 'active',
          setAtLastChance: false
        },
        {
          method: 'percentTotal',
          value: 7,
          state: 'link-active',
          class: "added-class",
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'active'
        }
      ]
    },
    values: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 47,
          state: 'active',
          setAtLastChance: false
        },
        {
          method: 'percentTotal',
          value: 25,
          state: 'link-active',
          class: "added-class",
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'active'
        }
      ]
    },
    references: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 58,
          state: 'active',
          setAtLastChance: false
        },
        {
          method: 'percentTotal',
          value: 47,
          class: "added-class",
          state: 'link-active',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'active'
        }
      ]
    },
    team: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 76,
          state: 'active',
          setAtLastChance: false
        },
        {
          method: 'percentTotal',
          value: 58,
          class: "added-class",
          state: 'link-active',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'active'
        }
      ]
    },
    news: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 90,
          state: 'active',
          setAtLastChance: false
        },
        {
          method: 'percentTotal',
          value: 76,
          class: "added-class",
          state: 'link-active',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'active'
        }
      ]
    },
    contact: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 100,
          state: 'active',
          setAtLastChance: false
        },
        {
          method: 'percentTotal',
          value: 90,
          class: "added-class",
          state: 'link-active',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'active'
        }
      ]
    },
    menu: {
      currentState: 'active',
      states: [
        {
          method: 'percentTotal',
          value: 7,
          state: 'active',
          setAtLastChance: false
        },
        {
          method: 'default',
          state: 'inactive'
        }
      ]
    }
  }

  constructor(
    private router: Router,
    private scrollimateService: ScrollimateService,
    private referencesService: ReferencesService,
    private teamService: TeamService,
    private route: ActivatedRoute,
    private newsService: NewsService
  ) {
    scrollimateService.setDefaultStates(this.scrollimateOptions.defaultStates);
  }

  ngOnInit() {
    this.getReferences();
    this.getTeam();
    this.getNews();
  }

  getReferences() {
    this.referencesService.getReferences().subscribe(
      data => {
        this.refs = data;
        // console.log(this.refs)
        // setTimeout(() => this.jumpToId( window.location.hash.substr(1) ), 100);
      },
      err => console.error(err)
    );
  }

  getTeam() {
    this.teamService.getTeam().subscribe(
      data => { this.members = data },
      err => console.error(err)
    );
  }

  getNews(){
    this.newsService.getNews().subscribe(
      data => { this.actus = data },
      err => console.error(err)
    );
  }

  jumpToId( fragment ) {

    // Use the browser to navigate
    window.location.hash = fragment;

    // But also scroll when routing / deep-linking to dynamic page
    // or re-clicking same anchor
    if (fragment) {
      const element = document.querySelector('#' + fragment);
      if (element) element.scrollIntoView();
    }
  }

  menu(event: any) {
    this.scrollimateOptions.menu.currentValue = event.currentValue || this.scrollimateOptions.menu.currentValue;
  }
  job(event: any) {
    this.scrollimateOptions.job.currentValue = event.currentValue || this.scrollimateOptions.job.currentValue;
  }
  values(event: any) {
    this.scrollimateOptions.values.currentValue = event.currentValue || this.scrollimateOptions.values.currentValue;
  }
  references(event: any) {
    this.scrollimateOptions.references.currentValue = event.currentValue || this.scrollimateOptions.references.currentValue;
  }
  team(event: any) {
    this.scrollimateOptions.team.currentValue = event.currentValue || this.scrollimateOptions.team.currentValue;
  }
  news(event: any) {
    this.scrollimateOptions.news.currentValue = event.currentValue || this.scrollimateOptions.news.currentValue;
  }
  contact(event: any) {
    this.scrollimateOptions.contact.currentValue = event.currentValue || this.scrollimateOptions.contact.currentValue;
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts